// extracted by mini-css-extract-plugin
export default {"spinnerContainer":"Loading_spinnerContainer__l-L8m","loadingSpinner":"Loading_loadingSpinner__zghGS","spinner":"Loading_spinner__bWZt3"};